module.exports = __webpack_public_path__ + "img/HomSlider7.0594ac55.png";